import { gameDifficulties, difficultyArray } from '../../data/difficulty';

const player = {
  displayName: '',
  playedClass: 'RANDOM',
  rules: [],
  excludedSkills: [],
  includedSkills: [],
  excludedPassiveSkills: [],
  includedPassiveSkills: [],
  tokens: 0,
};

export default {
  currentPhase: 0,
  currentGameDifficulty: gameDifficulties.normal,
  controlledPlayer: 0,
  rulesRerollCount: 0,
  phaseGoals: [],
  players: [player, player, player, player],
  phaseLoading: false,
  gameMode: 'normal',
  unlockedDifficulties: difficultyArray,
};
